module.exports = __webpack_public_path__ + "static/img/25.5047231.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/25.png
// module id = tX3B
// module chunks = 0